import Nullable from "@data-force/app/interfaces/nullable";
import {
    EditorType, ElementsValues, RefElementsMap, UploadsConfig,
} from "@data-force/app";
import {TranslateFunction} from "react-localize-redux";
import {ElementsValuesMap} from "@data-force/app/interfaces/store/reducers/schema";
import {TaskEntity} from "./task";
import {UploadFilesState, UploadsBucket} from "../../reducers/uploadFilesState";
import {Result} from "../../../../types/types";

export interface FileTypeAndExtension {
    fileType: string
    fileExtension: Nullable<string>
}

export enum FileValidationProcessStatus {
    READY,
    IN_PROGRESS,
    FINISHED
}

export interface FileValidationProcess {
    uid: string
    status: FileValidationProcessStatus
    handle?: number
}

export type ReferenceUnitMap = {
    [key: string]: string
};

export interface UploadsHolder {
    uploadsConfig: UploadsConfig
    name: string
    minCount?: number
    maxCount?: number
}

export interface UploadsHolderData {
    uploadsConfig: UploadsConfig
    collectionRefElements: RefElementsMap
    elementsValues: ElementsValues
    translate: TranslateFunction
    index: number
    translationPath: string
}

export interface UploadsData {
    uploadsHolders: UploadsHolder[]
    acceptedMimeTypes: string[]
    fileNamesList: string[]
}

export interface InitUploadsData {
    editor: Nullable<EditorType>
    collectionRefElements: RefElementsMap
    elementsValues: ElementsValues
    translate: TranslateFunction
    translationPath: string
    tasks: TaskEntity[]
    elementsValuesMap: ElementsValuesMap
    schemaKey: string
    uploadBucket: UploadsBucket
}

export interface TaskIdBucketKey {
    [taskId: string]: string
}

export interface FilterUploadsData {
    uploadReference: Nullable<string>
    batchUploads: UploadsConfig[]
    tasks: TaskEntity[]
    elementsValuesMap: ElementsValuesMap
    schemaKey: string
}

export interface FilterUploadsResult {
    filteredUploads: UploadsConfig[]
    operationalUploads: string[]
}

export interface OperationalUploadsData {
    uploadReference: string
    operationalTasks: TaskEntity[]
    elementsValuesMap: ElementsValuesMap
    schemaKey: string
}

export interface UploadsFileNamesData {
    fileNameReference: Nullable<string>
    tasks: TaskEntity[]
    elementsValuesMap: ElementsValuesMap
    schemaKey: string
    uploadBucket: UploadsBucket
}

export interface BucketKeyData {
    useBucketConfig: boolean
    uploadsHolder: UploadsHolder
    validBatchUploadsConfig: boolean
}

export interface BucketCountData {
    minCount: Nullable<number>
    maxCount: Nullable<number>
    uploaded: number
}

export interface DetermineUploadedFilesData {
    uploadsHolder: UploadsHolder
    uploadFiles: UploadFilesState
    validBatchUploadsConfig: boolean
}

export interface ValidByBucketsData {
    uploadsData: UploadsData
    uploadFiles: UploadFilesState
    validBatchUploadsConfig: boolean
}

export interface ExifrInfo {
    fileInfo: Nullable<Result>
    originFileObj: File
}
